import { DueDiligenceHistory } from '@/components/compliance-page/dueDiligenceHistoryPage';
import useRefresh from '@/hooks/use-refresh';
import { Helmet as Head } from 'react-helmet';

const DueDiligenceHistoryPage = () => {
  useRefresh();
  return (
    <>
      <Head>
        <title>Due Diligence History</title>
      </Head>
      <DueDiligenceHistory />
    </>
  );
};

export default DueDiligenceHistoryPage;
